import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import SydModal from '../../../../../commonDesign/SydModal'
import MapPipelineForm from './form'

const MapPipelineDialog = React.forwardRef(function MapPipelineDialog ({ onComplete }, ref) {
  const [dialogState, setDialogState] = useState({ open: false, processing: false })

  const close = useCallback(() => {
    setDialogState({ open: false, processing: false })
  }, [setDialogState])

  const handleComplete = useCallback((e) => {
    close()
    onComplete(e)
  }, [close, onComplete])

  useImperativeHandle(ref, () => ({
    open: (source) => setDialogState({ open: true, processing: false, source })
  }), [setDialogState])

  return (
    <SydModal
      title='Map Pipeline'
      open={dialogState.open}
      onClose={close}
      size='medium'
      position='top'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (<MapPipelineForm source={dialogState.source} onComplete={handleComplete} onCancel={close} />) : null}
      </div>
    </SydModal>
  )
})

MapPipelineDialog.propTypes = {
  onComplete: PropTypes.func
}

MapPipelineDialog.defaultProps = {
  onComplete: () => {}
}

export default MapPipelineDialog
